<div class="relative w-full h-full overflow-hidden rounded-2xl">
    <div #mapContainer id="map-container"></div>

    <!-- Animation Controls Overlay -->
    <div class="absolute bottom-6 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-3">
        <button (click)="toggleAnimation()"
            class="bg-blue-600/90 hover:bg-blue-500 text-white w-12 h-12 rounded-full shadow-lg shadow-blue-500/20 backdrop-blur-sm flex items-center justify-center transition-all active:scale-95 border border-white/20 group">
            <i class="fa-solid" [class.fa-play]="!isAnimating" [class.fa-pause]="isAnimating"
                style="font-size: 1.2rem;"></i>

            <!-- Tooltip -->
            <span
                class="absolute -top-10 scale-0 group-hover:scale-100 transition-all bg-slate-900/90 text-[10px] font-bold px-3 py-1.5 rounded-lg text-white whitespace-nowrap uppercase tracking-widest border border-white/10">
                {{ isAnimating ? 'Stop Tracker' : 'Play Journey' }}
            </span>
        </button>
        
        <!-- Offline Indicator -->
        <div *ngIf="isOfflineMode"
            class="bg-amber-500/90 backdrop-blur-md px-4 py-2 rounded-2xl border border-white/20 text-white flex flex-col items-center animate-pulse">
            <span class="text-[8px] font-bold text-slate-100 uppercase tracking-[0.2em] mb-0.5">Network</span>
            <span class="text-xs font-black font-mono flex items-center gap-2">
                <i class="fa-solid fa-wifi-slash"></i> OFFLINE
            </span>
        </div>

        <div *ngIf="isAnimating"
            class="bg-slate-900/80 backdrop-blur-md px-4 py-2 rounded-2xl border border-white/10 text-white flex flex-col items-center">
            <span class="text-[8px] font-bold text-slate-400 uppercase tracking-[0.2em] mb-0.5">Progress</span>
            <span class="text-xs font-black font-mono">{{ animationProgress }}%</span>
        </div>
    </div>
</div>